import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return sessionStorage.getItem('isLoggedIn') === 'true';
  });

  const logout = () => {
    setUser(null);
    setIsLoggedIn(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/login';
  };

  // Session timeout logik
  useEffect(() => {
    const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutter
    const checkSessionTimeout = () => {
      const lastActivity = localStorage.getItem('lastActivity');
      if (lastActivity && Date.now() - parseInt(lastActivity) > SESSION_TIMEOUT) {
        logout();
      }
    };

    const sessionCheck = setInterval(checkSessionTimeout, 60000);
    
    const updateLastActivity = () => {
      localStorage.setItem('lastActivity', Date.now().toString());
    };
    
    window.addEventListener('mousemove', updateLastActivity);
    window.addEventListener('keypress', updateLastActivity);
    window.addEventListener('click', updateLastActivity);
    window.addEventListener('scroll', updateLastActivity);

    updateLastActivity();

    return () => {
      window.removeEventListener('mousemove', updateLastActivity);
      window.removeEventListener('keypress', updateLastActivity);
      window.removeEventListener('click', updateLastActivity);
      window.removeEventListener('scroll', updateLastActivity);
      clearInterval(sessionCheck);
    };
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    setIsLoggedIn(true);
    sessionStorage.setItem('user', JSON.stringify(userData));
    sessionStorage.setItem('isLoggedIn', 'true');
    sessionStorage.setItem('token', token);
  };

  const updateUser = (updatedUser) => {
    setUser(updatedUser);
    sessionStorage.setItem('user', JSON.stringify(updatedUser));
  };

  const getUserPermissions = () => {
    if (!user) return { isAdmin: false, isConsultant: false, canManageClients: false };
    return {
      isAdmin: user.role === 'admin',
      isConsultant: user.role === 'consultant',
      canManageClients: user.role === 'admin' || user.role === 'consultant'
    };
  };

  return (
    <UserContext.Provider value={{
      user,
      isLoggedIn,
      login,
      logout,
      updateUser,
      getUserPermissions
    }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser må kun bruges inden for en UserProvider');
  }
  return context;
} 